module.exports = __webpack_public_path__ + "img/cart-shopping-fast.b70b675f.svg";